import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fieldNameRequired: {
    description: 'fieldName is required error message',
    defaultMessage: '{name} is a required field',
    id: '7yjf9w',
  },
  maximumCharactersWithOverage: {
    description: 'maximum of max characters including number of characters over message',
    defaultMessage: 'Maximum {max} characters <b>({overage} over)</b>',
    id: 'SJCm1q',
  },
  maximumCharacters: {
    description: 'maximum of max characters including number of characters',
    defaultMessage: 'Maximum {max} characters',
    id: 'qA1YQh',
  },
  maximumCharactersWithRemaining: {
    description: 'maximum of max characters including number of characters remaining message',
    defaultMessage: 'Maximum {max} characters <b>({remaining} remaining)</b>',
    id: 'VYHUhW',
  },
});
